<template>
<div>
    <h1 class="display-heading">Vaccination Partner Payout List</h1>
    <div class="table-responsive">
        <div ref="tableSection">
            <table ref="listTable" class="table table-hover">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Vaccine</th>
                        <th scope="col">Booking Date</th>
                        <th scope="col">Booked By</th>
                        <th scope="col">Status</th>
                        <th scope="col">Clinic</th>
                        <th scope="col">Payment Amount</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-show="vaccinations.length === 0">
                        <td :colspan="columnsCount" class="text-center font-italic">
                            {{isTableLoading ? "Loading Data": "No Data"}}
                        </td>
                    </tr>
                    <tr v-for="(vaccination, index) in vaccinations" :key="index">
                        <th scope="row">{{((pagination.currentPage - 1) * pagination.pageSize ) + index + 1}}</th>
                        <td>{{vaccination.vaccine}}</td>
                        <td>{{vaccination.bookingDate ? convertToUserReadableDateTime(vaccination.bookingDate)  : 'Payment not complete.'}}</td>
                        <td>{{vaccination.bookedBy}}</td>
                        <td>{{vaccination.status}}</td>
                        <td>{{vaccination.vaccinationCentre}}</td>
                        <td>RM {{vaccination.paymentAmount}}</td>
                        <td>
                            <router-link :to="{
                                'name': 'vaccination-detail',
                                'params': {'id': vaccination.vaccinationId}
                            }">
                            View Details
                            </router-link>
                        </td>
                    </tr>
                </tbody>

            </table>
        </div>

        <pagination v-model="pagination.currentPage"
            :totalPages="pagination.totalPages"
            :scrollPosition="pagination.scrollPosition">
        </pagination>
    </div>
</div>
</template>

<script>
import { convertToUserReadableDateTime } from '@/utilities';
import pagination from '@/components/pagination';
export default {
    'name': 'VaccinationPartnerPayoutList',
    'components': {
        pagination
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getVaccinations();
            });
        }
    },
    data () {
        return {
            convertToUserReadableDateTime,
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'vaccinations': []
        };
    },
    mounted () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.add('wide-version');

        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getVaccinations();
    },
    destroyed () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.remove('wide-version');
    },
    'methods': {
        getVaccinations () {
            this.axios.get('Vaccination/List', {
                'params': {
                    'page': this.pagination.currentPage,
                    'pageSize': this.pagination.pageSize,
                    'status': 3
                }
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.vaccinations = list.map((vaccination) => ({
                    'vaccine': vaccination.v,
                    'bookingDate': vaccination.bd,
                    'bookedBy': vaccination.bb,
                    'status': vaccination.st,
                    'vaccinationId': vaccination.vi,
                    'paymentAmount': vaccination.ppa,
                    'vaccinationCentre': vaccination.vc
                }));
            });
        }
    }
};
</script>

<style>

</style>
